module.exports.clientAddress = 'https://demo379.dataart.com';
module.exports.clientPort = '443';
module.exports.apiAddress = 'https://demo379be.dataart.com/api';
module.exports.winAuthAddress = 'https://demo379be.dataart.com/windows/';
module.exports.apiPort = '443';
module.exports.apiVersion = '1';
module.exports.version = '3.6.0'; // you should increase version berfore every new deploy to the production